import CalendarAppointmentIcon from 'components/atoms/SVG/CalendarAppointmentIcon.component';
import Banner from 'components/molecules/Banner';
import {
  AppBannersContext,
  BANNERS_STORAGE_KEYS,
} from 'contexts/AppBannersProvider';
import dayjs from 'dayjs';
import { useSubscriptionPlan } from 'hooks/Subscriptions';
import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SubscriptionPlanNameEnum } from 'types/users.types';

const TrialBanner: FC = () => {
  const { t } = useTranslation();

  const { dismissBanner } = useContext(AppBannersContext);

  const subscriptionPlan = useSubscriptionPlan();

  const trialExpirationDate = dayjs(subscriptionPlan?.end);

  const trialExpiresAfterNumOfDays = trialExpirationDate.diff(dayjs(), 'd');

  const recommendedPlanDisplayName = t(
    SubscriptionPlanNameEnum.taxes12,
  ).toUpperCase();

  return (
    <Banner
      Icon={CalendarAppointmentIcon}
      title={t(
        trialExpiresAfterNumOfDays === 1 || trialExpiresAfterNumOfDays === 0
          ? 'subscriptions.banner.trial.title_singular_temp'
          : 'subscriptions.banner.trial.title_temp',
        {
          planName: recommendedPlanDisplayName,
          days: trialExpiresAfterNumOfDays,
        },
      )}
      description={t('subscriptions.banner.trial.disclaimer') + ' '} // TODO: improve this at banner level
      href="/subscriptions"
      linkLabel={t('subscriptions.banner.trial2.cta', {
        recommendedPlan: recommendedPlanDisplayName,
      })}
      onDismiss={() =>
        dismissBanner(BANNERS_STORAGE_KEYS.TRIAL_BANNER_DISMISS_KEY)
      }
    />
  );
};

export default TrialBanner;
